import { useState, useEffect } from 'react';

const COOKIE = 'dark-mode';
const YEAR = 60 * 60 * 24 * 365;

function readCookie(): boolean {
  return document.cookie.split(';').some(c => c.trim() === `${COOKIE}=true`);
}

function writeCookie(val: boolean) {
  document.cookie = val
    ? `${COOKIE}=true; path=/; max-age=${YEAR}`
    : `${COOKIE}=; path=/; max-age=0`;
}

export function useDarkMode() {
  const [isDark, setIsDark] = useState<boolean>(readCookie);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    writeCookie(isDark);
  }, [isDark]);

  return { isDark, toggle: () => setIsDark(v => !v) };
}
